/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import {API_UPLOADS} from "../../api";
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

const Screen = ({loading, setting}) => {

	return (
        <>
            <Helmet>

                <meta name="description" content={setting.description}/>
                <meta name="keywords" content={setting.keyword}/>
                <meta name="author" content={setting.title}/> 

                <title>{setting.title}</title>

                <link rel="icon" href={API_UPLOADS + setting.favicon}/>
                <link rel="shortcut icon" href={API_UPLOADS + setting.favicon}/>
                <link rel="apple-touch-icon" href={API_UPLOADS + setting.favicon}/>
            </Helmet>
        </>
	);
}

export default Screen;
    